import React, { useState, useEffect, useCallback } from "react";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { userCredentials, routeInfo } from "recoilState/GlobalState";

import { migraTipoDePasoGet } from "services/services-mia/migra";
import Modal from "components/UI/Modal/Modal";
import { useService } from "components/route/ServiceRoute";

import XGrid from "components/UI/Grid/XGrid";
import { HeaderButton, Buttons } from "components";
import { Add, Cached, DeleteOutline, EditOutlined } from "@mui/icons-material";

import { DeleteModal, InsertModal, UpdateModal } from "./Actions";

import { migraTipoDePaso as titles } from "consts/titulos-de-tablas";
import { ACTIONS } from "consts/Actions";
import { Routes } from "consts/Routes-App";

import s from "styles/pages/Pages.module.scss";

export default function TipoDePaso() {
    const [modalDetails, setModalDetails] = useState({ isOpen: false });
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [rowSelected, setRowSelected] = useState({
        status: false,
        row: {},
    });
    
    const { service } = useService();

    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);

    const updateList = useCallback(async () => {
        setRowSelected({ status: false, row: {} });
        setIsLoading(true);
        setRows([]);
        const { result } = await migraTipoDePasoGet({}, credentials);
        setRows(
            (result || []).map((item) => {
                const {
                    migraTipoDePasoId,
                    migraTipoDePasoCod,
                    migraTipoDePasoNombre,
                    migraTipoDePasoVersion,
                } = item;

                return {
                    id: migraTipoDePasoId,
                    migraTipoDePasoId,
                    migraTipoDePasoCod,
                    migraTipoDePasoNombre,
                    migraTipoDePasoVersion,
                    [titles[0]]: migraTipoDePasoCod,
                    [titles[1]]: migraTipoDePasoNombre,
                };
            })
        );
        setIsLoading(false);
    }, [credentials]);

    useEffect(() => {
        setRoute(Routes.migraTipoPasoTable);
    }, [setRoute]);

    useEffect(() => {
        updateList();
    }, [service, updateList]);

    const handleClick = ({ procede, title }) => {
        setModalDetails({ title, procede, isOpen: true });
    };

    const closeModal = () => {
        setModalDetails({ isOpen: false });
    };

    return (
        <main className={s.main}>
            <Modal
                onClose={closeModal}
                open={modalDetails.isOpen}
                title={modalDetails.title}
            >
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <UpdateModal
                        tipoDePaso={rowSelected.row}
                        updateList={updateList}
                        closeModal={closeModal}
                    />
                )}
                {modalDetails.procede === ACTIONS.DELETE && (
                    <DeleteModal
                        tipoDePaso={rowSelected.row}
                        updateList={updateList}
                        closeModal={closeModal}
                    />
                )}
                {modalDetails.procede === ACTIONS.INSERT && (
                    <InsertModal
                        updateList={updateList}
                        closeModal={closeModal}
                    />
                )}
            </Modal>
            <div className={s.actions}>
                <Buttons>
                    <HeaderButton
                        text={"Actualizar"}
                        onClick={updateList}
                        disabled={rowSelected.row.id}
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text={"Agregar tipo de paso"}
                        handleClick={handleClick}
                        data={{
                            title: "Agregar tipo de paso",
                            procede: ACTIONS.INSERT,
                        }}
                        disabled={
                            rowSelected.row.id || service.servicioPermiso !== "E"
                        }
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        text={"Editar tipo de paso"}
                        handleClick={handleClick}
                        data={{
                            title: "Editar tipo de paso",
                            procede: ACTIONS.UPDATE,
                        }}
                        disabled={
                            !rowSelected.row.id ||
                            service.servicioPermiso !== "E"
                        }
                    >
                        <EditOutlined />
                    </HeaderButton>

                    <HeaderButton
                        text={"Eliminar tipo de paso"}
                        handleClick={handleClick}
                        data={{
                            title: "Eliminar tipo de paso",
                            procede: ACTIONS.DELETE,
                        }}
                        disabled={
                            !rowSelected.row.id ||
                            service.servicioPermiso !== "E"
                        }
                    >
                        <DeleteOutline />
                    </HeaderButton>
                </Buttons>
            </div>
            <div className={s.container}>
                <XGrid
                    rows={rows}
                    titles={titles}
                    loading={isLoading}
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected}
                />
            </div>
        </main>
    );
}
